/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SerialSeizureHistoryDto
 */
export interface SerialSeizureHistoryDto {
    /**
     * 
     * @type {number}
     * @memberof SerialSeizureHistoryDto
     */
    'duration'?: number;
    /**
     * 
     * @type {string}
     * @memberof SerialSeizureHistoryDto
     */
    'durationUnit'?: SerialSeizureHistoryDtoDurationUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof SerialSeizureHistoryDto
     */
    'frequencyCount'?: number;
    /**
     * 
     * @type {string}
     * @memberof SerialSeizureHistoryDto
     */
    'frequencyPeriod'?: SerialSeizureHistoryDtoFrequencyPeriodEnum;
    /**
     * 
     * @type {number}
     * @memberof SerialSeizureHistoryDto
     */
    'seizuresCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof SerialSeizureHistoryDto
     */
    'seriesCount'?: number;
}

/**
    * @export
    * @enum {string}
    */
export enum SerialSeizureHistoryDtoDurationUnitEnum {
    Nanoseconds = 'NANOSECONDS',
    Microseconds = 'MICROSECONDS',
    Milliseconds = 'MILLISECONDS',
    Seconds = 'SECONDS',
    Minutes = 'MINUTES',
    Hours = 'HOURS',
    Days = 'DAYS'
}
/**
    * @export
    * @enum {string}
    */
export enum SerialSeizureHistoryDtoFrequencyPeriodEnum {
    Year = 'YEAR',
    Month = 'MONTH',
    Day = 'DAY'
}


